import React from 'react';
import clsx from 'classnames';
import './index.css';
import Banner from './components/Banner';
import { usePageTitle } from '../../hooks';
import Field from './components/Field';
import Customer from './components/Customer';

const Certificate = () => {
  usePageTitle('资质证书');
  return (
    <div
      className={clsx('certificate')}
      style={{ minHeight: window.innerHeight }}
    >
      {/* 顶部Banner */}
      <Banner />
      {/* 服务领域 */}
      <Field />
      {/* 合作客户 */}
      <Customer />
    </div>
  );
};

export default Certificate;
